import Cards from "./Cards";
export default function Test() {
  return (
    <div className="card-container">
      <Cards name={"TODO App"} />
      <Cards name={"TODO App"} />
      <Cards name={"TODO App"} />
      <Cards name={"TODO App"} />
      <Cards name={"TODO App"} />
      <Cards name={"TODO App"} />
      <Cards name={"TODO App"} />
    </div>
  );
}
